import React, { ReactNode } from 'react';
import { LDProvider, LDSingleKindContext } from 'launchdarkly-react-client-sdk';
import { useConfig } from './ConfigContext';
import { useInstanceId } from './InstanceIdContext';

interface FeatureFlagProviderProps {
  children: ReactNode;
}

const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({
  children,
}) => {
  const { LAUNCH_DARKLY_CLIENT_ID } = useConfig();
  const { instanceId } = useInstanceId();
  const context: LDSingleKindContext = {
    key: instanceId || '',
    kind: 'organization',
  };
  return (
    <LDProvider
      clientSideID={LAUNCH_DARKLY_CLIENT_ID}
      context={context}
      timeout={2}
    >
      {children}
    </LDProvider>
  );
};

export default FeatureFlagProvider;
